import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { toast } from "react-toastify";
import { residenceContactAssignment, residenceContact } from "../services/soar";
import ExpandDiv from "../common/ExpandDiv";
import FloatingInput from "../common/FloatingInput";

function PropertyContacts({ data, refreshData }) {
  const [contacts, setContacts] = useState([]);
  const [contactData, setContactData] = useState({
    title: "",
    firstName: "",
    lastName: "",
    name: "",
    phone: "",
    email: "",
    address: "",
    city: "",
    state: "",
    zip: "",
    effective: "",
    expiration: "",
  });
  const [showAssign, setShowAssign] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [showMatches, setShowMatches] = useState(true);

  useEffect(() => {
    getContacts();
  }, []);

  const getContacts = async () => {
    const body = {
      command: "query",
      keyword: "viewall",
      application:
        process.env.REACT_APP_ENVIRONMENT === "Production"
          ? "5dae139e-d052-4bd8-bf4a-499a31ac3c15"
          : "58990f83-8566-4ba8-b4b5-584a64e4cba1",
    };
    const data = await residenceCall(body, "contact");
    setContacts(data.data);
  };

  const residenceCall = async (body, type) => {
    const data =
      type === "contact"
        ? await residenceContact(body)
        : await residenceContactAssignment(body);
    return data;
  };

  const saveNewContact = async () => {
    const body = {
      command: "insert",
      application: data.application,
      firstName: contactData.firstName,
      lastName: contactData.lastName,
      name:
        contactData.name !== "" &&
        contactData.name !== `${contactData.firstName} ${contactData.lastName}`
          ? contactData.name
          : `${contactData.firstName} ${contactData.lastName}`,
      phone: contactData.phone,
      email: contactData.email,
      address: contactData.address,
      city: contactData.city,
      state: contactData.state,
      zip: contactData.zip,
      title: contactData.title,
      modifiedBy: JSON.parse(localStorage.getItem("safyInfo")).user.azureId,
    };

    const response = await residenceCall(body, "contact");
    if (response.code === "success") {
      toast.success(`Contact Created Successfully`);
      await saveAssignment(response.id);
    } else {
      console.log("Error Response", response);
      toast.error(`Error Creating Contact. ${response.message}`);
    }
  };

  const updateContact = async () => {
    const body = {
      command: "update",
      id: contactData.id,
      application: data.application,
      firstName: contactData.firstName,
      lastName: contactData.lastName,
      name:
        contactData.name !== "" &&
        contactData.name !== `${contactData.firstName} ${contactData.lastName}`
          ? contactData.name
          : `${contactData.firstName} ${contactData.lastName}`,
      phone: contactData.phone,
      email: contactData.email,
      address: contactData.address,
      city: contactData.city,
      state: contactData.state,
      zip: contactData.zip,
      title: contactData.title,
      modifiedBy: JSON.parse(localStorage.getItem("safyInfo")).user.azureId,
    };
    const response = await residenceCall(body, "contact");
    if (response.code === "success") {
      toast.success(`Contact Updated Successfully`);
      setShowEdit(false);
      clearContactData();
      refreshData();
    } else {
      toast.error(`Error Updating Contact. ${response.message}`);
    }
  };

  const saveAssignment = async (id) => {
    const body = {
      command: "insert",
      application: data.application,
      residence: data.id,
      contact: id,
      effective: new Date(),
      modifiedBy: JSON.parse(localStorage.getItem("safyInfo")).user.azureId,
    };

    const response = await residenceCall(body, "assignment");
    if (response.code === "success") {
      toast.success(`Contact Created Successfully`);
      clearContactData();
      setShowAssign(false);
      refreshData();
    } else {
      toast.error(`Error Creating Contact. ${response.message}`);
    }
  };

  const deactivateAssignment = async (id) => {
    const body = {
      command: "deactivate",
      id: id,
      application: data.application,
      modifiedBy: JSON.parse(localStorage.getItem("safyInfo")).user.azureId,
    };

    const response = await residenceCall(body, "assignment");
    if (response.code === "success") {
      toast.success(`Contact Deactivated`);
      refreshData();
    } else {
      toast.error("Error updating contact status");
    }
  };

  const clearContactData = () => {
    setContactData({
      title: "",
      firstName: "",
      lastName: "",
      name: "",
      phone: "",
      email: "",
      address: "",
      city: "",
      state: "",
      zip: "",
      effective: "",
      expiration: "",
    });
  };

  const matchFields = (field, label) => {
    return contactData[field] !== "" &&
      contacts.filter((c) =>
        c[field]?.toUpperCase().includes(contactData[field]?.toUpperCase())
      ).length > 0 ? (
      <>
        <div className="h6 my-2">{`Matching ${label}`}</div>
        {contacts
          .filter((c) =>
            c[field]?.toUpperCase().includes(contactData[field]?.toUpperCase())
          )
          .map((c, index) => (
            <div
              key={`mf-${index}-${c.id}`}
              className="row rounded border border-dark card-safy bg-warning p-2 mb-1"
            >
              <div className="col-2 fw-bold">{c.name}</div>
              <div className="col-2">{c.title}</div>
              <div className="col-3">{c.phone}</div>
              <div className="col-3">{c.email}</div>
              <div className="col-2">
                <div
                  className="btn btn-sm btn-primary px-2 float-end"
                  onClick={() => saveAssignment(c.id)}
                >
                  Select
                </div>
              </div>
            </div>
          ))}
      </>
    ) : null;
  };

  const matchNames = () => {
    return contacts.filter(
      (c) =>
        (contactData.name !== "" &&
          c.name?.toUpperCase().includes(contactData.name.toUpperCase())) ||
        (contactData.firstName !== "" &&
          c.firstName
            ?.toUpperCase()
            .includes(contactData.firstName.toUpperCase())) ||
        (contactData.lastName !== "" &&
          c.lastName
            ?.toUpperCase()
            .includes(contactData.lastName.toUpperCase()))
    ).length > 0 ? (
      <>
        <div className="h6 my-2">{`Matching Names`}</div>
        {contacts
          .filter(
            (c) =>
              (contactData.name !== "" &&
                c.name
                  ?.toUpperCase()
                  .includes(contactData.name.toUpperCase())) ||
              (contactData.firstName !== "" &&
                c.firstName
                  ?.toUpperCase()
                  .includes(contactData.firstName.toUpperCase())) ||
              (contactData.lastName !== "" &&
                c.lastName
                  ?.toUpperCase()
                  .includes(contactData.lastName.toUpperCase()))
          )
          .map((c, index) => (
            <div
              key={`pc-${index}-${c.id}`}
              className="row rounded border border-dark card-safy bg-warning p-2 mb-1"
            >
              <div className="col-2 fw-bold">{c.name}</div>
              <div className="col-2">{c.title}</div>
              <div className="col-3">{c.phone}</div>
              <div className="col-3">{c.email}</div>
              <div className="col-2">
                <div
                  className="btn btn-sm btn-primary px-2 float-end"
                  onClick={() => saveAssignment(c.id)}
                >
                  Select
                </div>
              </div>
            </div>
          ))}
      </>
    ) : null;
  };

  return (
    <>
      {showEdit === true ? (
        <Modal
          show={showEdit}
          onHide={() => {
            setShowEdit(false);
            clearContactData();
          }}
          animation={false}
          size="lg"
        >
          <Modal.Header closeButton className="bg-safy-info text-white">
            <Modal.Title>Property Contact</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="rounded border border-2 border-danger ps-2 pe-4 py-1 mb-2">
              <FloatingInput
                className="card-safy mb-2"
                label="First Name"
                name="firstName"
                value={contactData.firstName}
                onChange={(e) =>
                  setContactData({
                    ...contactData,
                    firstName: e.target.value,
                  })
                }
              />
              <FloatingInput
                className="card-safy mb-2"
                label="Last Name"
                name="lastName"
                value={contactData.lastName}
                onChange={(e) =>
                  setContactData({
                    ...contactData,
                    lastName: e.target.value,
                  })
                }
              />
              <div className="ms-4 mb-2">Or</div>
              <FloatingInput
                className="card-safy mb-2"
                label="Company Name"
                name="name"
                value={contactData.name}
                onChange={(e) =>
                  setContactData({
                    ...contactData,
                    name: e.target.value,
                  })
                }
              />
            </div>
            <FloatingInput
              className="card-safy mb-2"
              label="Title or Role"
              name="title"
              value={contactData.title}
              onChange={(e) =>
                setContactData({
                  ...contactData,
                  title: e.target.value,
                })
              }
            />
            <FloatingInput
              className="card-safy mb-2"
              label="Phone"
              name="phone"
              value={contactData.phone}
              onChange={(e) =>
                setContactData({
                  ...contactData,
                  phone: e.target.value,
                })
              }
            />
            <FloatingInput
              className="card-safy mb-2"
              label="Email"
              name="email"
              value={contactData.email}
              onChange={(e) =>
                setContactData({
                  ...contactData,
                  email: e.target.value,
                })
              }
            />
            <FloatingInput
              className="card-safy mb-2"
              label="Address"
              name="address"
              value={contactData.address}
              onChange={(e) =>
                setContactData({
                  ...contactData,
                  address: e.target.value,
                })
              }
            />
            <FloatingInput
              className="card-safy mb-2"
              label="City"
              name="city"
              value={contactData.city}
              onChange={(e) =>
                setContactData({
                  ...contactData,
                  city: e.target.value,
                })
              }
            />
            <FloatingInput
              className="card-safy mb-2"
              label="State"
              name="state"
              value={contactData.state}
              onChange={(e) =>
                setContactData({
                  ...contactData,
                  state: e.target.value,
                })
              }
            />
            <FloatingInput
              className="card-safy mb-2"
              label="Zip"
              name="zip"
              value={contactData.zip}
              onChange={(e) =>
                setContactData({
                  ...contactData,
                  zip: e.target.value,
                })
              }
            />
          </Modal.Body>
          <Modal.Footer className="bg-safy2-4">
            <div
              className="btn btn-sm btn-success"
              onClick={() => {
                updateContact();
              }}
            >
              Update Contact
            </div>
            <div
              className="btn btn-sm btn-danger"
              onClick={() => {
                setShowEdit(false);
                clearContactData();
              }}
            >
              Cancel
            </div>
          </Modal.Footer>
        </Modal>
      ) : null}
      {showAssign === true ? (
        <Modal
          show={showAssign}
          onHide={() => {
            setShowAssign(false);
            clearContactData();
          }}
          animation={false}
          size="xl"
        >
          <Modal.Header closeButton className="bg-safy-info text-white">
            <Modal.Title>Property Contact Information</Modal.Title>
          </Modal.Header>
          <Modal.Body className="bg-light">
            <div className="row">
              <div className="col-4">
                <div className="rounded border border-2 border-danger ps-2 pe-4 py-1 mb-2">
                  <FloatingInput
                    className="card-safy mb-2"
                    label="First Name"
                    name="firstName"
                    value={contactData.firstName}
                    onChange={(e) =>
                      setContactData({
                        ...contactData,
                        firstName: e.target.value,
                      })
                    }
                  />
                  <FloatingInput
                    className="card-safy mb-2"
                    label="Last Name"
                    name="lastName"
                    value={contactData.lastName}
                    onChange={(e) =>
                      setContactData({
                        ...contactData,
                        lastName: e.target.value,
                      })
                    }
                  />
                  <div className="ms-4 mb-2">Or</div>
                  <FloatingInput
                    className="card-safy mb-2"
                    label="Company Name"
                    name="name"
                    value={contactData.name}
                    onChange={(e) =>
                      setContactData({
                        ...contactData,
                        name: e.target.value,
                      })
                    }
                  />
                </div>
                <FloatingInput
                  className="card-safy mb-2"
                  label="Title or Role"
                  name="title"
                  value={contactData.title}
                  onChange={(e) =>
                    setContactData({
                      ...contactData,
                      title: e.target.value,
                    })
                  }
                />
                <FloatingInput
                  className="card-safy mb-2"
                  label="Phone"
                  name="phone"
                  value={contactData.phone}
                  onChange={(e) =>
                    setContactData({
                      ...contactData,
                      phone: e.target.value,
                    })
                  }
                />
                <FloatingInput
                  className="card-safy mb-2"
                  label="Email"
                  name="email"
                  value={contactData.email}
                  onChange={(e) =>
                    setContactData({
                      ...contactData,
                      email: e.target.value,
                    })
                  }
                />
                <FloatingInput
                  className="card-safy mb-2"
                  label="Address"
                  name="address"
                  value={contactData.address}
                  onChange={(e) =>
                    setContactData({
                      ...contactData,
                      address: e.target.value,
                    })
                  }
                />
                <FloatingInput
                  className="card-safy mb-2"
                  label="City"
                  name="city"
                  value={contactData.city}
                  onChange={(e) =>
                    setContactData({
                      ...contactData,
                      city: e.target.value,
                    })
                  }
                />
                <FloatingInput
                  className="card-safy mb-2"
                  label="State"
                  name="state"
                  value={contactData.state}
                  onChange={(e) =>
                    setContactData({
                      ...contactData,
                      state: e.target.value,
                    })
                  }
                />
                <FloatingInput
                  className="card-safy mb-2"
                  label="Zip"
                  name="zip"
                  value={contactData.zip}
                  onChange={(e) =>
                    setContactData({
                      ...contactData,
                      zip: e.target.value,
                    })
                  }
                />
                <div
                  className="rounded bg-success text-white border border-dark mt-2 p-2 text-center"
                  role="button"
                  onClick={() => {
                    saveNewContact();
                  }}
                >
                  Save as New Contact
                </div>
              </div>
              <div className="col">
                <div
                  className={`btn btn-sm ${
                    showMatches ? "btn-danger" : "btn-success"
                  } mt-2`}
                  onClick={() => setShowMatches(!showMatches)}
                >
                  {showMatches ? "Hide Matches" : "Show Matches"}
                </div>
                {showMatches && matchNames()}
                {showMatches && matchFields("phone", "Phones")}
                {showMatches && matchFields("email", "Emails")}
                {showMatches && matchFields("address", "Addresses")}
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer className="bg-safy2-4">
            <div
              className="btn btn-sm btn-danger"
              onClick={() => {
                setShowAssign(false);
                clearContactData();
              }}
            >
              Cancel
            </div>
          </Modal.Footer>
        </Modal>
      ) : null}
      <ExpandDiv
        className={`border p-2 my-2 card-safy`}
        title={
          data.type === "FosterHome"
            ? "Foster Home Members"
            : "Property Contacts"
        }
        expandStatus={true}
      >
        <div className="row">
          <div className="col-11"></div>
          <div className="col-1">
            <i
              className="fas fa-plus-circle fa-xl text-primary float-end me-2 mb-2"
              role="button"
              onClick={() => {
                setShowAssign(true);
              }}
            ></i>
          </div>
        </div>
        <div className="w-100">
          {data.propertyContacts
            ?.filter((c) => c.contact?.active)
            .map((contact, pcindex) => {
              return (
                <div key={`mc-${pcindex}`} className="d-inline-block w-25 p-2">
                  <div className="rounded border border-dark bg-light card-safy p-2">
                    <div className="row">
                      <div className="col-9">
                        <div className="fw-bold">{contact.contact.title}</div>
                      </div>
                      <div className="col-3">
                        <i
                          className="fas fa-pen text-primary me-2"
                          role="button"
                          onClick={() => {
                            setContactData({
                              id: contact.contact.id,
                              title: contact.contact.title || "",
                              firstName: contact.contact.firstName || "",
                              lastName: contact.contact.lastName || "",
                              name: contact.contact.fullName,
                              phone: contact.contact.phone || "",
                              email: contact.contact.email || "",
                              address: contact.contact.address || "",
                              city: contact.contact.city || "",
                              state: contact.contact.state || "",
                              zip: contact.contact.zip || "",
                              effective: contact.contact.effective || "",
                              expiration: contact.contact.expiration || "",
                            });
                            setShowEdit(true);
                          }}
                        />
                        <i
                          className="fas fa-trash text-danger"
                          role="button"
                          onClick={() => deactivateAssignment(contact.id)}
                        />
                      </div>
                    </div>
                    <div>{contact.contact.fullName}</div>
                    {contact.contact.firstName !== "" &&
                      contact.contact.fullName !==
                        `${contact.contact.firstName} ${contact.contact.lastName}` && (
                        <div>
                          {`${contact.contact.firstName} ${contact.contact.lastName}`}
                        </div>
                      )}
                    <div>{contact.contact.phone}</div>
                    <div>{contact.contact.email}</div>
                    <div>
                      {` ${contact.contact.address} ${contact.contact.city}
                      ${contact.contact.state} ${contact.contact.zip}`}
                    </div>
                  </div>
                </div>
              );
            })}
        </div>
      </ExpandDiv>
    </>
  );
}

export default PropertyContacts;
